import { useEffect, useContext } from 'react';
import { mapPinType } from '../constants/products';
import { buildHotelDetailURL } from './HotelListingCard/buildHotelDetailURL';
import { ChatbotDataContext } from '../context/ChatbotDataContext';
export const useSetHotelPinOnMapHook = ({
  displayResult,
  args
}) => {
  const {
    setHotelPinOnMap
  } = useContext(ChatbotDataContext);
  useEffect(() => {
    var _a;
    const hotelLocationList = (_a = displayResult === null || displayResult === void 0 ? void 0 : displayResult.filter(hotel => hotel.location && hotel.location.latitude && hotel.location.longitude)) === null || _a === void 0 ? void 0 : _a.map(hotel => {
      return {
        type: mapPinType.HOTEL,
        name: (hotel === null || hotel === void 0 ? void 0 : hotel.name) || 'hotel',
        description: hotel === null || hotel === void 0 ? void 0 : hotel.description,
        location: hotel.location,
        lat: hotel.location.latitude,
        lng: hotel.location.longitude,
        hotelDetailURL: buildHotelDetailURL(args, hotel),
        hotel
      };
    });
    setHotelPinOnMap(hotelLocationList);
  }, [displayResult === null || displayResult === void 0 ? void 0 : displayResult.length]);
};